import { billingSummaryWidgetByIdSelector } from "./billingSummaryWidgetByIdSelector";
import { RootState } from "@/store/store";
import { objectToUrl } from "@/components/utils/helpers/dataToUrlToDataConvertors";
import { currentDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/currentDashboardIdSelector";
import { dashboardDimensionsCategoryIdsByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDimensionsCategoryIdsByDashboardIdSelector";

export const billingSummaryWidgetBillingExplorerUrlSelector = (
  state: RootState,
  widgetId: string,
) => {
  const widget = billingSummaryWidgetByIdSelector(state, widgetId);

  if (!widget) {
    return "";
  }

  const dashboardId = currentDashboardIdSelector(state);

  const dimensionCategoryIds =
    dashboardDimensionsCategoryIdsByDashboardIdSelector(
      state,
      dashboardId ?? "",
    );

  const path = objectToUrl([{ dates: widget.dates }]);

  let url = `/resource-explorer/${widget.view_id}?path=${path}`;

  if (dimensionCategoryIds?.dimension_id && dimensionCategoryIds?.category_id) {
    url = `${url}&categoryId=${dimensionCategoryIds?.category_id}&dimensionId=${dimensionCategoryIds?.dimension_id}`;
  }

  return url;
};
